<template>
  <div class="profile">
    <div class="pad-l">
      <!-- Mostra Info solo se user è disponibile -->
      <Info v-if="user" :user="user" :products="[...products]" :videos="videos"/>
    </div>

    <div class="container-fullhd">
      <div class="pad-l">
        <!-- Mostra Calendar solo se user ed eventi sono pronti -->
        <Calendar v-if="user && events.length" :user="user" :events="events" @enroll="onEnroll" @dropout="onDropOut" @refresh-products="refreshProducts"/>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import api from '@/api'
import pop, { notif } from '@/pop'
import LoadingOverlay from '@/components/global/LoadingOverlay'
import Info from '@/components/dashboard/Info'
import Calendar from '@/components/dashboard/Calendar'

export default {
  name: 'profile',

  components: {
    Info,
    Calendar
  },

  data() {
    return {
      user: null,
      products: [],
      events: [],
      videos: [],
      endpoint: null
    }
  },

  methods: {
    async onEnroll(event) {
      try {
        let ev = await api.event(event.id).enroll()

        for (let i in this.events)
          if (this.events[i].id === ev.id) {
            this.$set(this.events, i, ev)
            break
          }

        if (ev.message) {
          notif.warn(ev.message, 5000) // ⚠️ messaggio arancione
        } else {
          notif.done('Prenotazione completata! Ricordati che puoi cancellarti entro max 24 ore dall’inizio della classe', 4000)
        }

        await this.refreshProducts()

      } catch (err) {
        console.error(err.dev_msg || err)
        notif.error(err.display_msg || err)
      }
    },

    async onDropOut(event) {
      try {
        let ev = await api.event(event.id).dropout()

        for (let i in this.events)
          if (this.events[i].id === ev.id) {
            this.$set(this.events, i, ev)
            break
          }

        if (ev.bDropped) {
          notif.warn('La prenotazione è stata cancellata nelle 24 ore precedenti l\'allenamento quindi verrà scalata in automatico, contatta il tuo coach per chiarimenti', 5000)
        } else {
          notif.done('Prenotazione cancellata.', 3000)
        }

        await this.refreshProducts()

      } catch (err) {
        console.error(err.dev_msg || err)
        notif.error(err.display_msg || err)
      }
    },

    async refreshProducts() {
      try {
        const products = await api.user().getProducts()
        this.products = products
      } catch (err) {
        console.error('Errore nel refresh dei prodotti:', err)
      }
    }
  },

  async beforeRouteEnter(to, from, next) {
    const endpoint = api.user('me')
    const fromDate = moment().day(1).startOf('day')
    const toDate = moment(fromDate).add(28, 'days')

    pop.push({ comp: LoadingOverlay })

    try {
      const [user, events, products] = await Promise.all([
        endpoint.get('subscriptions'),
        api.event().getRange({ from: fromDate.format(), to: toDate.format() }),
        api.user().getProducts()
      ])

      const videos = user.membership ? await api.user().getVideos() : []

      next(vm => {
        vm.user = user
        vm.events = events
        vm.products = products
        vm.videos = videos
        vm.endpoint = endpoint
      })
    } catch (err) {
      console.error(err.dev_msg || err)
      notif.error(err.display_msg || err)
      next(vm => {
        vm.user = null
        vm.events = []
      })
    } finally {
      pop.pop()
    }
  }
}
</script>